<template>
  <v-app>
    <v-dialog v-model="welcome" max-width="1000px" @keydown.esc="welcome = false">
      <v-card class="text-xs-center">
        <v-card-text>
          <p>
            <img src="./assets/splash.png" style="max-height: 400px; max-width: 100%; cursor: pointer;" @click.stop="welcome = false"/>
          </p>
          <v-alert color="blue" :value="true">Twenty six species now available</v-alert>
          <p>Restore &amp; Renew responds to the need for ecological restoration practitioners to incorporate the latest science into their toolkit, helping them to restore diverse, resilient and adaptable ecosystems.</p>
          <p><v-btn color="primary" @click.stop="welcome = false">Enter Restore &amp; Renew webtool</v-btn></p>
          <p>More information about the Restore &amp; Renew project is available <a href="https://www.rbgsyd.nsw.gov.au/science/restore-renew">here</a>, or email us at <a href="mailto:Restore.Renew@rbgsyd.nsw.gov.au">Restore.Renew@rbgsyd.nsw.gov.au</a>.</p>
          <p>Thanks to The NSW Environmental Trust, HSBC and DArT for their support of this project:</p>
          <a target="_blank" href="http://www.environment.nsw.gov.au/grants/envtrust.htm"><img src="./assets/Trust-waratah-colour-small.png" class="welcome-sponsor-logos" /></a>
          <a target="_blank" href="http://www.about.hsbc.com.au/"><img src="./assets/HSBC-small-logo-no-tagline_C.jpg" class="welcome-sponsor-logos" /></a>
          <a target="_blank" href="http://www.diversityarrays.com"><img src="./assets/DART_logo.jpg" class="welcome-sponsor-logos" /></a>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="speciesInfoModal" content-class="infoModal" max-width="1200px" @keydown.esc="speciesInfoModal = false">
      <v-card>
        <v-card-text class="py-0">
          <v-alert outline color="blue" :value="true">
            The information provided here is reproduced in the results document which you can download as a pdf.
          </v-alert>
        </v-card-text>
        <v-card-title class="headline">
          <span v-html="canonicalSpeciesNameFormatted"></span>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="speciesInfoModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <p v-if="canonicalSpeciesCommonNames"><b>Common names:</b>Common names: {{canonicalSpeciesCommonNames}}</p>
          <p v-if="canonicalSpeciesSynonyms"><b>Synonyms:</b> {{canonicalSpeciesSynonyms}}</p>
          <p v-if="specialZoneSpecies" style="color:Tomato;"><b>NOTE:</b> This species includes one or more areas in which special conditions apply to the collection or handling of the species, or parts of it such as seeds. These special zones are highlighted on the maps produced by this webtool.</p>
          <p v-if="showZoneMessage" v-html="zoneMessage" style="color:Tomato;"></p>
          <p v-if="canonicalSpeciesSpeciesInfo" v-html="canonicalSpeciesSpeciesInfo"></p>
          <v-layout row class="text-xs-center">
            <v-flex sm6>
              <figure>
                <img v-if="canonicalSpeciesPath" :src="'data/images/species/' + canonicalSpeciesPath + '_distribution.png'" :alt="canonicalSpecies + ' distribution'">
                <figcaption style="font-size:85%">Herbarium records (Sourced from ALA)</figcaption>
              </figure>
            </v-flex>
            <v-flex sm6>
              <div v-if="canonicalSpecies in speciesTaxon && speciesTaxon[canonicalSpecies].photos">
                <div v-if="speciesTaxon[canonicalSpecies].photos.length == 1">
                  <figure>
                    <img v-if="canonicalSpeciesPath" :src="'data/images/species/' + speciesTaxon[canonicalSpecies].photos[0].file" :alt="canonicalSpecies">
                    <figcaption style="font-size:85%">{{speciesTaxon[canonicalSpecies].photos[0].caption}}</figcaption>
                  </figure>
                </div>
                <div v-else>
                  <figure>
                    <v-carousel :cycle="false" v-model="speciesPhotoCarouselIndex">
                      <v-carousel-item v-for="(photo,i) in speciesTaxon[canonicalSpecies].photos" :src="'data/images/species/' + photo.file" :key="i"></v-carousel-item>
                    </v-carousel>
                  </figure>
                  <figcaption style="font-size:85%; margin-top: 5px">{{speciesTaxon[canonicalSpecies].photos[speciesPhotoCarouselIndex].caption}}</figcaption>
                </div>
              </div>
              <div v-else>
                <figure>
                  <img src="data/images/species/placeholder.png" alt="No image available">
                </figure>
              </div>
            </v-flex>
          </v-layout>
          <v-divider class="my-3"></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.stop="speciesInfoModal=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpModal" content-class="infoModal" fullscreen>
    </v-dialog>

    <v-dialog v-model="resultsModal" content-class="infoModal resultsModal" fullscreen>
      <v-card>
        <v-card-text>
          <div class="printSection">
            <v-layout row>
              <v-flex xs6>
                <v-card-text class="py-0">
                  <v-alert outline color="black" :value="true">
                    <p>This document is to support you in making decisions about your restoration project. It provides the following information:</p>
                    <ul>
                      <li>A brief species description of your selected species</li>
                      <li>An interpretation of the distribution of environmental suitability for the selected species, and how this distribution is expected to change in the future</li>
                      <li>The geographic area representing the <i>local genetic provenance</i> for this species at the site you selected</li>
                      <li>The distribution of current and future climatic conditions that are representative of your selected site</li>
                      <li>Suggestions on how to implement a range of restoration scenarios</li>
                    </ul>
                    <p></p>
                    <p><b>Please note:</b> The Restore &amp; Renew project uses species names from the National Species List (NSL) maintained by the Atlas of Living Australia. The plant names on the NSL are derived from the Australian Plant Census maintained by the Council of Heads of Australasian Herbaria (CHAH).</p>
                  </v-alert>
                </v-card-text>
              </v-flex>
              <v-flex xs6>
                <figure>
                  <img src="./assets/logo.png" alt="Restore & Renew logo">
                </figure>
              </v-flex>
            </v-layout>
            <v-card-title class="headline">
              <span v-html="canonicalSpeciesNameFormatted"></span>
            </v-card-title>
            <v-card-text class="py-0">
              <p v-if="canonicalSpeciesCommonNames"><b>Common names:</b>Common names: {{canonicalSpeciesCommonNames}}</p>
              <p v-if="canonicalSpeciesSynonyms"><b>Synonyms:</b> {{canonicalSpeciesSynonyms}}</p>
              <p v-if="specialZoneSpecies" style="color:Tomato;"><b>NOTE:</b> This species includes one or more areas in which special conditions apply to the collection or handling of the species, or parts of it such as seeds. These special zones are highlighted on the maps produced by this webtool.</p>
              <p v-if="showZoneMessage" v-html="zoneMessage" style="color:Tomato;"></p>
              <p v-if="canonicalSpeciesSpeciesInfo" v-html="canonicalSpeciesSpeciesInfo"></p>
              <v-layout row class="text-xs-center avoid-page-break">
                <v-flex sm6>
                  <figure>
                    <img v-if="canonicalSpeciesPath" :src="'data/images/species/' + canonicalSpeciesPath + '_distribution.png'" :alt="canonicalSpecies + ' distribution'">
                    <figcaption style="font-size:85%">Herbarium records (Sourced from ALA)</figcaption>
                  </figure>
                </v-flex>
                <v-flex sm6>
                  <div v-if="canonicalSpecies in speciesTaxon && speciesTaxon[canonicalSpecies].photos">
                    <div v-if="speciesTaxon[canonicalSpecies].photos.length == 1">
                      <figure>
                        <img v-if="canonicalSpeciesPath" :src="'data/images/species/' + speciesTaxon[canonicalSpecies].photos[0].file" :alt="canonicalSpecies">
                        <figcaption style="font-size:85%">{{speciesTaxon[canonicalSpecies].photos[0].caption}}</figcaption>
                      </figure>
                    </div>
                    <div v-else>
                      <figure>
                        <v-carousel :cycle="false" v-model="speciesPhotoCarouselIndex">
                          <v-carousel-item v-for="(photo,i) in speciesTaxon[canonicalSpecies].photos" :src="'data/images/species/' + photo.file" :key="i"></v-carousel-item>
                        </v-carousel>
                      </figure>
                      <figcaption style="font-size:85%; margin-top: 5px">{{speciesTaxon[canonicalSpecies].photos[speciesPhotoCarouselIndex].caption}}</figcaption>
                    </div>
                  </div>
                  <div v-else>
                    <figure>
                      <img src="data/images/species/placeholder.png" alt="No image available">
                    </figure>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div> <!-- printSection -->

          <v-divider class="my-3"></v-divider>
          <div class="printSection">
            <h2>Summary of genetic findings</h2>
            <span v-html="canonicalSpeciesGeneticsInfo"></span>
          </div> <!-- printSection -->
          <v-divider class="my-3"></v-divider>
          <div class="printSection">
            <h2>Collection and restoration scenarios</h2>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <div class="defaultMarker"></div>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Selected location</v-list-tile-title>
                <v-list-tile-sub-title v-if="lng && lat">Latitude: {{lat}}, Longitude: {{lng}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <p>For your selected species and location, you have a number restoration scenarios to choose amongst. Each section below gives advice on how to follow each one using our current understanding of how genetic diversity for this species varies across the landscape.</p>
            <v-alert outline color="error" :value="true">
              <b>You may need to obtain collecting permits from relevant authorities, as well as obtaining permission to enter private properties.</b>
            </v-alert>
          </div> <!-- printSection -->
          <v-divider class="my-3"></v-divider>
          <div class="printSection">
            <h3>Local provenance scenario</h3>
            <v-layout row class="section">
              <v-flex sm6 class="pr-4">
                <p>The un-greyed region on the map is the 'genetically local area' or local neighbourhood, based on genetic data.</p>
                <p>If the objective of your project is to restore this species from local provenance only, where possible, we encourage collection of material from multiple locations within the local provenance area to increase genetic variation, overall fitness and long-term viability of your restoration project.</p>
                <p>In general, when sampling plant material for restoration, sampling from a greater number of individuals and from individuals further apart within the genetic neighbourhood will lead to greater genetic diversity. The graph below (based on a modelled simulation) shows that we can expect the genetic diversity captured to increase as more plants are collected, especially if the plants are far enough apart (thus decreasing the likelihood of them being closely related). The blue curve shows an outcome for a "mixed" strategy, where half the plants are collected near the restoration site, and the other half were collected from a site at the boundary of the local neighbourhood. Such a strategy produces greater diversity than collecting the same number of plants from the same location (red curve).</p>
                <p>The blue curve shows an outcome for a sampling strategy that is not restricted to a single location. In this case, as an example, half the plants were collected from a location near the restoration site, and the other half were collected from a location close to the boundary of the local genetic provenance. Such a strategy produces much greater diversity (blue curve) than collecting the same number of plants from the same location (red curve). So even when restricting your sampling to the ‘local provenance’, it is generally best to sample from multiple individuals sourced from multiple locations. Although the extent of local provenance varies between locations and species, opportunities to maximise diversity are generally present.</p>
                <v-layout row class="avoid-page-break">
                  <img src="data/images/diversitySamplingCurve.png" alt="Diversity-sampling curve" width="344" height="500">
                  <v-list dense>
                    <v-list-tile avatar>
                      <v-list-tile-avatar>
                        <div class="defaultMarker small"></div>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Selected location</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile avatar>
                      <v-list-tile-avatar>
                        <v-icon color="herbarium_records" small>lens</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Herbarium records</v-list-tile-title>
                        <v-list-tile-sub-title><em>Sourced from ALA</em></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile avatar>
                      <v-list-tile-avatar>
                        <v-icon color="recommended_collection_area">cloud_circle</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Recommended collection area</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-layout>
                <p>For your selected species and location there are additional restoration strategies to choose from other than the basic ‘local provenance’ scenario described above. The section below suggests how to follow additional scenarios using our current understanding of how genetic diversity varies across the landscape for this species.</p>
              </v-flex>
              <v-flex sm6>
                <div id="resultsMapGeneticDiversity" class="map"></div>
              </v-flex>
            </v-layout>
          </div> <!-- printSection -->
          <v-divider class="my-3"></v-divider>
          <div class="printSection">
            <h3>Matched local climate scenarios</h3>
            <v-layout row class="section">
              <v-flex sm6 class="pr-4">
                <p>The areas that match the climate at your chosen site are shown shaded in purple. It is possible that this species has made subtle adaptations to the local environment. We cannot determine the degree of local adaptation with currently available genetic samples; it typically requires extensive experimental study. To make allowance for possible local adaptation, you may decide to collect material from similar environments to that present at your selected location. This information enables you to plan one or more replicable ‘composite provenancing’ strategy/ies that can be fitted within a comparative experimental model, or can be planned as a ‘one-off’ and monitored through time. Three possible scenarios include: </p>
                  <ol>
                    <li><b>Local provenance, local climate</b>: if you aim to plant genetically local material that fits climate (currently) similar to your selected site, collect from multiple locations in the following areas:
                      <ul>
                        <li>The areas that fall within the overlap between the local genetic provenance (non-greyed area on the map), and the climate matched regions (highlighted in purple).</li>
                      </ul>
                    </li>
                    <li><b>Local composite</b>: if you aim to plant genetically local material, but include the range of climatic conditions present within your local genetic provenance, collect from multiple locations in the two areas described below:
                      <ul>
                        <li>The local genetic provenance sites (non-greyed area on the map) that fall within climatic conditions that are matched to your selected site (purple highlight).</li>
                        <li>The local genetic provenance sites (non-greyed area on the map) that fall outside matched climatic conditions.</li>
                      </ul>
                    </li>
                    <li><b>Mixed composite</b>: if you aim to collect plant material from climatic conditions similar to those at your site but from multiple genetic provenances, collect from multiple locations in the two areas described below:
                      <ul>
                        <li>The overlap between the local genetic provenance (non-greyed area on the map), and regions climatically matched to your selected site (highlighted in purple).</li>
                        <li>Areas climatically matching the conditions on your selected site but found outside the local genetic provenance (highlighted in purple within the greyed area).</li>
                      </ul>
                    </li>
                  </ol>
                <v-list dense>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <div class="defaultMarker small"></div>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Selected location</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="herbarium_records" small>lens</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Herbarium records</v-list-tile-title>
                      <v-list-tile-sub-title><em>Sourced from ALA</em></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="recommended_collection_area">cloud_circle</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Recommended collection area</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="similar_environments_current">stop</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Simlar environments (Current)</v-list-tile-title>
                      <v-list-tile-sub-title style="padding-left: 31px"><em>(Matches current site conditions)</em></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex sm6>
                <div id="resultsMapCurrentClimateMatch" class="map"></div>
              </v-flex>
            </v-layout>
          </div> <!-- printSection -->
          <v-divider class="my-3"></v-divider>
          <div class="printSection">
            <h3>Matched to future climate scenarios</h3>
            <v-layout row class="section">
              <v-flex sm6 class="pr-4">
                <v-card>
                  <p>The areas highlighted in orange on this map show areas that match the climatic conditions predicted for <i>your</i> selected site in 2050, but are present in the landscape <i>now</i>. If you aim to plant ‘climate ready’ material that is matched to the conditions predicted to prevail at your site in the future (potentially pre-adapted to these future conditions), include collections from areas highlighted in orange.  Two possible ‘climate ready’ scenarios include:</p>
                  <ol>
                    <li><b>Local provenance, climate adjusted</b>: If you aim to plant genetically local material fitting the conditions predicted for your selected restoration site in the future, collect from multiple locations in the following area:
                      <ul>
                        <li>Areas matching the local genetic provenance area with future predicted conditions (orange highlights within non-greyed areas). Note future-matched conditions are not always available within the local provenance area.</li>
                      </ul>
                   </li>
                  <li><b>Predictive</b>: If you aim to plant material fitting the conditions predicted for your selected restoration site in the future, but not only sourced from the local genetic provenance, collect from multiple locations in the two areas described below:
                    <ul>
                      <li>Areas matching the local genetic provenance area with future predicted conditions (orange highlights within non-greyed areas). Note future-matched conditions are not always available within the local provenance area.</li>
                      <li>Areas matching the conditions predicted for your site in the future but outside the local genetic provenance (i.e. intersection between orange highlights and greyed areas of the map).</li>
                    </ul>
                  </li>
                 </ol>
               </v-card>
                <v-list dense>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <div class="defaultMarker small"></div>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Selected location</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="herbarium_records" small>lens</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Herbarium records</v-list-tile-title>
                      <v-list-tile-sub-title><em>Sourced from ALA</em></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="recommended_collection_area">cloud_circle</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Recommended collection area</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon color="similar_environments_future">stop</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Similar environments (2050)</v-list-tile-title>
                      <v-list-tile-sub-title style="padding-left: 31px"><em>(Matches future conditions at site in 2050)</em></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex sm6>
                <div id="resultsMapFutureClimateMatch" class="map"></div>
              </v-flex>
            </v-layout>
          </div> <!-- printSection -->
          <v-divider class="my-3"></v-divider>
          <p class="text-xs-center">Text and images &copy; 2020 NSW Government</p>
          <span class="print permalink-print">Printed from {{permalink_display}} on {{currentDate}}</span>
        </v-card-text>
        <v-card-actions class="pa-5 resultActions">
          <v-container grid-list-xs class="shareLink">
            <v-layout row>
              <v-flex xs10 class="permalink-box">
                <span id="permalink">{{permalink_display}}</span>
              </v-flex>
              <v-flex xs2 v-if="false">
                <v-tooltip bottom>
                  <v-btn id="copyLinkToClipboard" flat icon slot="activator" color="primary" data-clipboard-target="#permalink">
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                  <span>Copy link to clipboard</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <p class="caption shareLink">Copy and paste this link to share the current view</p>
          </v-container>
          <v-spacer></v-spacer>
          <v-btn
            v-on:click="print"
            color="primary"
            :loading="printing"
            :disabled="printing"
            >
            <v-icon left dark>print</v-icon>
            Print
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Added PDW 2020-09-01 -->
    <v-dialog v-if="!resultsModal" v-model="zoneMessageModal" content-class="infoModal" max-width="800px">
      <v-card>
        <v-card-title class="headline red lighten-2">About your selected site...
          <v-spacer></v-spacer>
          <v-btn icon @click.native="zoneMessageModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text><p v-html="zoneMessage"></p></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="zoneMessageModal=false">I accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer
      fixed
      permanent
      width="400"
      v-model="drawer"
      app
      :mini-variant="collapsed"
      mini-variant-width="60"
      >
      <v-container>
        <a href="/"><img class="logo" src="./assets/logo.png" alt="Restore and Renew" /></a>
      </v-container>
      <v-container class="pt-0">
        <v-btn class="pa-2 mb-4"
          color="primary"
          outline
          block
          href="/"
          >
          <v-icon left>home</v-icon>
          Return to main site
        </v-btn>
        <v-btn color="info" v-on:click="displayHelpClicked()"><v-icon left>help</v-icon>Help</v-btn>
        <span>Opens in a new tab</span>
      </v-container>
      <v-stepper v-model="step" v-on:input="stepperChanged" vertical non-linear>
        <v-stepper-step step="1" :complete="(lat && lng) ? true : false" editable :rules="[() => { return !this.noSpeciesAtThisLocation } ]">
          Location
          <small>Choose a location for restoration</small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <p>Click on a location on the map or enter WGS84 coordinates</p>
          <v-text-field
            label="Latitude"
            v-model="latInput"
            clearable
            :rules="latitudeRules"
            ></v-text-field>
          <v-text-field
            label="Longitude"
            v-model="lngInput"
            clearable
            :rules="longitudeRules"
            ></v-text-field>
          <v-btn
            color="primary"
            @click="submitClicked()"
            >Submit
          </v-btn>
          <v-alert filled color="error" icon="warning" :value="noSpeciesAtThisLocation">
            <strong>Currently no data available for this location.</strong>
          </v-alert>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="selectedSpecies ? true : false" editable>
          Species
          <small>Choose a species for restoration</small>
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-autocomplete
            v-bind:items="speciesDropdown"
            v-model="selectedSpecies"
            label="Species name"
            dense
            no-data-text="null"
            hint="Only species with genetic data for your location are shown"
            persistent-hint
            class="mb-2"
            ></v-autocomplete>
            <v-alert filled color="warning" icon="warning" :value="noLatLong">
              <strong>Please return to Step 1 and select a location.</strong>
          </v-alert>

        </v-stepper-content>
        <v-stepper-step step="3" :complete="(lng && lat && selectedSpecies) ? true : false" editable edit-icon="check">
          <v-layout row justify-space-between>
            <v-flex xs10>
              Results<br>
              <small>View results</small>
            </v-flex>
            <v-flex xs2>
              <v-avatar size="36px">
                <v-progress-circular indeterminate color="primary" v-show="(inFlightRequest_gdm_prediction || inFlightRequest_current_climate_match || inFlightRequest_future_climate_match) ? true : false"></v-progress-circular>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-stepper-step>
        <v-stepper-content step="3" class="stepper-results" style="padding: 8px 40px 8px 23px">
          <h1 class="canonicalSpecies">{{canonicalSpecies}}
          <v-btn id="speciesInfo" color="info" v-if="canonicalSpecies" @click.stop="speciesInfoModal = true; speciesInfoModalClicked()" icon small>
            <v-icon dark>info</v-icon>
          </v-btn>
        </h1>
          <h1 v-if="!canonicalSpecies" class="canonicalSpecies">No results</h1>
          <p>
            <span v-if="speciesPlantNETurl || speciesAPCurl">View at </span><a target="_blank" :href="speciesPlantNETurl" v-if="speciesPlantNETurl">PlantNET</a><span v-if="speciesPlantNETurl && speciesAPCurl"> or </span><a target="_blank" :href="speciesAPCurl" v-if="speciesAPCurl">Atlas of Living Australia</a>
          </p>
          <v-list dense class="results-list" v-if="canonicalSpecies">
            <v-list-tile v-if="specialZoneSpecies">
              <v-list-tile-avatar size=25>
                <v-icon color="specialZones" x-large>stop</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="font-size:20px">Special conditions apply</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar size=25>
                <v-icon color="herbarium_records" small>lens</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-checkbox
                    label="Herbarium records"
                    v-model="herbarium_records_toggle"
                    :disabled="herbarium_records_state == 'initial'"
                    :loading="inFlightRequest_herbarium_records ? true : false"
                    ></v-checkbox>
                </v-list-tile-title>
                <v-list-tile-sub-title style="padding-left: 31px"><em>(Sourced from ALA)</em></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar size=25>
                <v-icon color="recommended_collection_area" medium>cloud_circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-checkbox
                    label="Recommended collection area"
                    v-model="recommended_collection_area_toggle"
                    :disabled="recommended_collection_area_state == 'initial'"
                    :loading="inFlightRequest_gdm_prediction ? true : false"
                    ></v-checkbox>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar size=25>
                <v-icon color="similar_environments_current" x-large>stop</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-checkbox
                    label="Similar environments (Current)"
                    v-model="similar_environments_current_toggle"
                    :disabled="similar_environments_current_state == 'initial'"
                    :loading="inFlightRequest_current_climate_match ? true : false"
                    ></v-checkbox>
                </v-list-tile-title>
                <v-list-tile-sub-title style="padding-left: 31px"><em>(Matches current site conditions)</em></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar size=25>
                <v-icon color="similar_environments_future" x-large>stop</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-checkbox
                    label="Similar environments (2050)"
                    v-model="similar_environments_future_toggle"
                    :disabled="similar_environments_future_state == 'initial'"
                    :loading="inFlightRequest_future_climate_match ? true : false"
                    ></v-checkbox>
                </v-list-tile-title>
                <v-list-tile-sub-title style="padding-left: 31px"><em>(Matches future conditions at site in 2050)</em></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-alert outline type="error" :value="resultsError">
            {{resultsErrorMessage}}
          </v-alert>
          <v-tooltip right open-delay="0">
            <v-btn
              id="downloadResults"
              color="primary"
              v-if="canonicalSpecies"
              @click.stop="downloadResults()"
              :disabled="(inFlightRequest_gdm_prediction || inFlightRequest_current_climate_match || inFlightRequest_future_climate_match || inFlightRequest_downloadResults) ? true : false"
              slot="activator"
              :loading="!!inFlightRequest_downloadResults"
              block
              >
              Download Results
              <span slot="loader"><v-icon dark class="loading-spin">cached</v-icon>Downloading results...</span>
            </v-btn>
            <span>as a PDF for viewing and printing</span>
          </v-tooltip>
          <v-progress-linear
            v-if="!!inFlightRequest_downloadResults"
            color="info"
            height="10"
            :value="downloadResultsProgress"
            ></v-progress-linear>
        </v-stepper-content>
      </v-stepper>
      <v-layout mt-4 v-if="canonicalSpecies || lng || lat">
        <v-btn
          class="mx-auto"
          v-on:click="reset"
          color="secondary"
          small
          >
          <v-icon left dark>clear</v-icon>
          Reset
        </v-btn>
      </v-layout>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid fill-height class="map-container">
        <v-slide-y-transition mode="out-in">
          <v-layout column align-center>
            <div id="map"></div>
          </v-layout>
        </v-slide-y-transition>
      </v-container>
      <v-btn-toggle mandatory v-model="map_background" class="map-background">
        <v-btn flat value="streets-v10">
          Map
        </v-btn>
        <v-btn flat value="satellite-streets-v10">
          Satellite
        </v-btn>
      </v-btn-toggle>
    </v-content>
    <v-btn
      id="drawerCollapseButton"
      color="primary"
      absolute
      top
      left
      fab
      small
      :data-expanded="!collapsed"
      v-on:click="collapsed = !collapsed"
      @transitionend="drawerCollapseToggled"
      >
      <v-icon v-if="collapsed">arrow_forward</v-icon>
      <v-icon v-else>arrow_back</v-icon>
    </v-btn>
  </v-app>
</template>

<script>
  import * as RandR from './RandR'
  import { pleaseWait } from 'please-wait'

  window.loadingScreen = pleaseWait({
    backgroundColor: Theme.primary,
    loadingHtml: "<p class='loading-message'>Loading Restore and Renew</p><div class='sk-chasing-dots'><div class='sk-child sk-dot1'></div><div class='sk-child sk-dot2'></div></div>"
  });

  import mapboxgl from 'mapbox-gl'
  import 'mapbox-gl/dist/mapbox-gl.css'

  if (!mapboxgl.supported()) {
    window.loadingScreen.updateOption('loadingHtml', "<p class='loading-message'>Restore and Renew</p><p class='loading-message'>You need to upgrade your browser with <a href='https://get.webgl.org/'>WebGL support</a> to use this application.</p>");
  }

  import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
  import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'

  mapboxgl.accessToken = 'pk.eyJ1IjoicmVzdG9yZWFuZHJlbmV3IiwiYSI6ImNqYzlucmtxYjAwbnkyd3F3YXUyMGxsdjMifQ.17jNpwzb5KRvTp7AO4v9Qg'

  import { json, request } from 'd3-request'
  import queryString from 'query-string'
  import whichPolygon from 'which-polygon'
  import bbox from '@turf/bbox'
  import Clipboard from 'clipboard'
  import _ from 'lodash'
  import * as topojson from 'topojson-client'
  import mask from '@turf/mask'
  import difference from '@turf/difference'
  import combine from '@turf/combine'
  import MobileDetect from 'mobile-detect'
  import Theme from './Theme'
  import * as Style from './Style'
  import Tether from 'tether'
  import DefaultMarker from './DefaultMarker'

  const q = queryString.parse(location.search);

  const resultsModalMapIds = ['resultsMapGeneticDiversity', 'resultsMapCurrentClimateMatch', 'resultsMapFutureClimateMatch'];

  export default {
    mounted () {
      this.$nextTick(function () {
        window.print = (function () { this.resultsModal = true }).bind(this)

        if (q.lat && q.lng && q.species && !('edit' in q)) {
          // if a lat,lng,species are provided without the edit flag, skip loading the application and go straight to the results
          this.loadApplication = false;
          this.resultsModal = true;
          this.welcome = false;
          window.loadingScreen.finish();

          // if skipping map loading, then still need to check for speciesTaxon etc.
          if (window.speciesTaxon) {
            this.speciesList = this.speciesList.concat(Object.keys(window.speciesTaxon)).sort();
            this.speciesTaxon = window.speciesTaxon;

            this.checkLoaded('species');
          } else {
            json('data/species.json', (data) => {
              this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
              this.speciesTaxon = data;

              this.checkLoaded('species');
            });
          }
          //json('data/synonyms.json', (data) => {
          //  this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
          //  this.synonyms = data;

          //  this.checkLoaded('synonyms');
          //});
        }

        // Added PDW 2020-08-30
        json('data/specialZone.topo.json', (data) => {
          this.specialZoneGeoJSON = topojson.feature(data, data.objects.specialZone);
          this.specialZoneQuery = whichPolygon(this.specialZoneGeoJSON);
          this.determineInSpecialZone([this.lng, this.lat]);
          this.updateZoneWithCanonicalSpecies(this.canonicalSpecies);

          this.checkLoaded('specialZone');
        });

        // Added PDW 2020-08-30
        json('data/hasSpecialZone.json', (data) => {
          this.hasSpecialZone = data;
          this.updateZoneWithCanonicalSpecies(this.canonicalSpecies);

          this.checkLoaded('hasSpecialZone');
        });

        // Added PDW 2020-08-31
        json('data/zoneMessages.json', (data) => {
          this.zoneMessages = data;
          this.determineInSpecialZone([this.lng, this.lat])
          this.updateZoneWithCanonicalSpecies(this.canonicalSpecies);

          this.checkLoaded('zoneMessages');
        });

        this.tether = new Tether({
          element: '#drawerCollapseButton',
          target: '.v-navigation-drawer',
          attachment: 'top right',
          targetAttachment: 'top right',
          constraints: [{
            to: 'window',
            pin: true
          }],
          offset: '0 -20px'
        });

        var defaultMarkerElements = document.querySelectorAll('.defaultMarker');
        Array.prototype.forEach.call(defaultMarkerElements, (el) => {
          el.appendChild(DefaultMarker({}));
        });

        var self = this;

        if (this.loadApplication) {
          this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox:///mapbox/streets-v9',
            center: [147.16, -32.94],
            zoom: 4,
            dragRotate: false
          });
          // fit to NSW
          this.map.fitBounds([139.965,-38.030,155.258,-27.839], { duration: 0 });

          this.map.addControl(new mapboxgl.NavigationControl({
            showCompass: false
          }));

          this.map.addControl(new mapboxgl.ScaleControl());

          this.geolocate = new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
            trackUserLocation: true
          });
          this.geolocate.on('geolocate', function (position) {
            if (!self.lng && !self.lat) {
              self.lng = position.coords.longitude;
              self.lat = position.coords.latitude;
            }

            this.$gtag.event('geolocate_success', {
              event_category: 'interaction',
              event_label: 'geolocate_success'
            })
          });
          this.geolocate.on('error', function () {
            this.$gtag.event('geolocate_error', {
              event_category: 'interaction',
              event_label: 'geolocate_error'
            })
          });
          this.map.addControl(this.geolocate);

          var md = new MobileDetect(window.navigator.userAgent);
          if (md.mobile()) {
            var click = new window.Event('click');
            setTimeout(function() {
              if (self.geolocate._geolocateButton) {
                self.geolocate._geolocateButton.dispatchEvent(click);
              }
            },1000);
          }

          this.map.addControl(new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            country: 'au',
            placeholder: 'Find a place'
          }), 'top-left');

          this.marker = new mapboxgl.Marker();

          /* URL query params */
          if ('welcome' in q) {
            this.welcome = (q.welcome === 'true'); // coerce to boolean
          }
          // the rest can only be set once the map loads

          this.map.on('load', () => {
            this.mapLoaded = true;
            if (this.enableLocationSelectionWhenLoaded) {
              this.map.getCanvasContainer().style.cursor = 'crosshair';
              this.map.on('click', this.locationClick);
              this.enableLocationSelectionWhenLoaded = false;
            }

            /* map load dependent URL query params */
            ['lat', 'lng'].forEach((k) => {
              if (k in q) {
                self[k] = q[k];
              }
            });

            if ('species' in q) {
              this.selectedSpecies = q.species;
              // canonical species should be set by watch: selectedSpecies
            }

            if ('speciesInfoModal' in q) {
              this.speciesInfoModal = (q.speciesInfoModal === 'true'); // coerce to boolean
            }

            this.map.addSource('herbarium_records', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Style.herbarium_records , 'waterway-label');

            // Added PDW 2020-08-31
            this.map.addSource('special_zone', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Style.specialZones, 'waterway-label');
            this.specialZone_state = 'loaded';
            this.updateZoneWithCanonicalSpecies(this.canonicalSpecies)

            this.map.addSource('gdm_prediction', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Style.gdm_prediction);
            this.gdm_predition_state = 'loaded';
            this.recommended_collection_area_state = 'loaded';

            this.map.addSource('current_climate_match', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Style.current_climate_match, 'housenum-label');
            this.similar_environments_current_state = 'loaded';

            this.map.addSource('future_climate_match', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Object.assign({}, Style.future_climate_match, { layout: { visibility: 'none' } }), 'current_climate_match');
            this.similar_environments_future_state = 'loaded';

            this.map.addSource('domain-mask', {
              type: 'geojson',
              data: this.emptyGeoJSON
            });
            this.map.addLayer(Style.domain_mask, 'herbarium_records');
            this.checkLoaded('map');
          });

          if (window.speciesTaxon) {
              this.speciesList = this.speciesList.concat(Object.keys(window.speciesTaxon)).sort();
              this.speciesTaxon = window.speciesTaxon;

              this.checkLoaded('species');
          } else {
            json('data/species.json', (data) => {
              this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
              this.speciesTaxon = data;

              this.checkLoaded('species');
            });
          }

          //json('data/synonyms.json', (data) => {
          //  this.speciesList = this.speciesList.concat(Object.keys(data)).sort();
          //  this.synonyms = data;

          //  this.checkLoaded('synonyms');
         // });

          json('data/domain.topo.json', (data) => {
            this.domainGeoJSON = topojson.feature(data, data.objects.domain);
            this.domainQuery = whichPolygon(this.domainGeoJSON);

            this.checkLoaded('domain');
          });

          // automatically select link when you click on the input
          document.getElementById('permalink').addEventListener('click', () => {
            var el = document.getElementById('permalink');

            var range, selection;

            if (window.getSelection && document.createRange) {
              selection = window.getSelection();
              range = document.createRange();
              range.selectNodeContents(el);
              selection.removeAllRanges();
              selection.addRange(range);
            } else if (document.selection && document.body.createTextRange) {
              range = document.body.createTextRange();
              range.moveToElementText(el);
              range.select();
            }
          });

        } else {
          if (window.speciesTaxon) {
            this.speciesTaxon = window.speciesTaxon;
          }

          if (window.gdm_prediction) {
            this.gdm_prediction = window.gdm_prediction;
          }

          if (window.gdm_prediction_masked) {
            this.gdm_prediction_masked = window.gdm_prediction_masked;
          }

          if (window.gdm_prediction_bbox) {
            this.gdm_prediction_bbox = window.gdm_prediction_bbox;
          }

          if (window.current_climate_match) {
            this.current_climate_match = window.current_climate_match;
          }

          if (window.future_climate_match) {
            this.future_climate_match = window.future_climate_match;
          }

          ['lat', 'lng'].forEach((k) => {
            if (k in q) {
              self[k] = q[k];
            }
          });

          if ('species' in q) {
            this.selectedSpecies = q.species;
          }
          if ('canonicalSpecies' in q) {
            this.canonicalSpecies = q.canonicalSpecies;
          }
        }
        new Clipboard('#copyLinkToClipboard');
      });
    },
    data () {
      return {
        welcome: false,
        componentsToLoad: {
          map: true,
          domain: true,
          species: true,
          //synonyms: true,
          specialZone: true,
          hasSpecialZone: true,
          zoneMessages: true
        }, // list of components we expect to load before removing the loading screen

        mapLoaded: false, // changed to true when map has loaded
        enableLocationSelectionWhenLoaded: false, // if the stepper is set to location before the map has loaded, this will be true to set the map up for location selection when it is loaded

        collapsed: false,

        drawer: true,
        step: 1, // initially at step 1 in the process

        canonicalSpecies: null, // canonical species (root species if a synonym was choosen)
        selectedSpecies: null, // selected species (could be a synonym)

        speciesList: [], // populated from remote json, powers species autocomplete select
        speciesTaxon: {}, // populated from remote json
        //synonyms: {}, // populated from remote json

        domainQuery: null, // function for point in polygon test identifying species valid for a location
        speciesForThisLocation: null, // species list for this location
        noSpeciesAtThisLocation: false, // if true, it means there are no species available at the selected location
        noLatLong: true,
        lat: null, // location latitude
        lng: null, // location longitude
        latInput: null, // manually entered latitude
        lngInput: null, // manually entered longitude

        // Added PDW 2020-08-28
        inSpecialZone: false,
        specialZoneIndex: null,
        specialZoneQuery: null,
        specialZoneGeoJSON: null,
        specialZoneSpecies: false,
        zoneMessages: null,
        zoneMessage: null,
        hasSpecialZone: null, // populated from remote json; Added by PDW 2020-08-28
        zone: null, // calculated geojson special zone for this species

        speciesInfoModal: false,
        resultsModal: false,
        zoneMessageModal: false,
        loadApplication: true,

        helpModal: null, // Make helpModal reactive

        speciesPhotoCarouselIndex: 0,

        map_background: 'streets-v10',

        emptyGeoJSON: { type: 'FeatureCollection', features: [] },

        inFlightRequest_downloadResults: null,

        inFlightRequest_herbarium_records: null,
        inFlightRequest_gdm_prediction: null,
        inFlightRequest_current_climate_match: null,
        inFlightRequest_future_climate_match: null,

        data_gdm_prediction: null,
        data_gdm_prediction_masked: null,
        data_current_climate_match: null,
        data_future_climate_match: null,

        resultsError: false,
        resultsErrorMessage: "Error calculating results, however a partial result may be shown. This can happen if the server is experiencing issues, or if you've made too many requests. Wait a minute before trying again.",

        downloadResultsProgress: 0,

        printing: false,

        // validation rules for long/lat input
        // Modified PDW 2018-09-20: enforce item completion of lat or long values before moving to step 2
        longitudeRules: [
          (v) => Number.isFinite(Number(v)) || 'Coordinate must be a number',
          (v) => -180 <= Number(v) && Number(v) <= 180 || 'Longitude must be between -180 and 180',
          (v) => !!v || 'A value for Longitude is required'
        ],
        latitudeRules: [
          (v) => Number.isFinite(Number(v)) || 'Coordinate must be a number',
          (v) => -90 <= Number(v) && Number(v) <= 90 || 'Latitude must be between -90 and 90',
          (v) => !!v || 'A value for Latitude is required'
        ],

        /* layer states
          - initial - page is still loading disable to prevent toggle before layer exists
          - loaded - new data loaded
        */
        herbarium_records_state: 'initial',
        recommended_collection_area_state: 'initial',
        similar_environments_current_state: 'initial',
        similar_environments_future_state: 'initial',
        specialZone_state: 'initial',

        // layer default toggle states (need to keep this in sync with addLayer initial visibility)
        herbarium_records_toggle: true,
        recommended_collection_area_toggle: true,
        similar_environments_current_toggle: true,
        similar_environments_future_toggle: false
      }
    },
    computed: {
      speciesDropdown: function () {
        return this.speciesForThisLocation; // || this.speciesList;
      },
      permalink: function () {
        var query = {};
        if (this.lng && this.lat) {
          query.lng = this.lng;
          query.lat = this.lat;
        }
        if (this.canonicalSpecies) {
          query.species = this.canonicalSpecies;
        }
        if (this.selectedSpecies && this.selectedSpecies !== this.canonicalSpecies) {
          query.selectedSpecies = this.selectedSpecies;
        }
        return '/?' + queryString.stringify(query);
      },
      permalink_display: function () {
        return 'https://www.restore-and-renew.org.au' + this.permalink;
      },
      currentDate: function () {
        return new Date().toString();
      },
      speciesPlantNETurl: function () {
        if (this.canonicalSpecies in this.speciesTaxon) {
          return this.speciesTaxon[this.canonicalSpecies].plantNETurl;
        } else {
          return null;
        }
      },
      speciesAPCurl: function () {
        if (this.canonicalSpecies in this.speciesTaxon) {
          return this.speciesTaxon[this.canonicalSpecies].apcURL;
        } else {
          return null;
        }
      },
      canonicalSpeciesPath: function () {
        return this.canonicalSpecies ? this.canonicalSpecies.replace(' ', '_') : null;
      },
      canonicalSpeciesNameFormatted: function () {
        return (this.canonicalSpecies in this.speciesTaxon) ? this.speciesTaxon[this.canonicalSpecies].nameFormatted : null;
      },
      canonicalSpeciesCommonNames: function () {
        return (this.canonicalSpecies in this.speciesTaxon) ? this.speciesTaxon[this.canonicalSpecies].commonNames : null;
      },
      canonicalSpeciesSynonyms: function () {
        return (this.canonicalSpecies in this.speciesTaxon) ? this.speciesTaxon[this.canonicalSpecies].synonyms.replace(/;/g, ', ') : null;
      },
      canonicalSpeciesSpeciesInfo: function () {
        return (this.canonicalSpecies in this.speciesTaxon) ? this.speciesTaxon[this.canonicalSpecies].speciesInfo : null;
      },
      canonicalSpeciesGeneticsInfo: function () {
        return (this.canonicalSpecies in this.speciesTaxon) ? this.speciesTaxon[this.canonicalSpecies].speciesGeneticsInfo : null;
      },
      showZoneMessage: function () {
        return this.inSpecialZone && this.hasSpecialZone && this.hasSpecialZone[this.canonicalSpecies] === 'TRUE';
      }
    },
    watch: {
      lng: function (val) {
        this.locationUpdated();
      },
      lat: function (val) {
        this.locationUpdated();
      },
      lngInput: function (val) {
        if (!val) {
          this.lng = this.lngInput;
        }
      },
      latInput: function (val) {
        if (!val) {
          this.lat = this.latInput;
        }
      },

      selectedSpecies: function (val) {
        this.canonicalSpecies = val;
      },

      inSpecialZone: function (val) {
        if (val && !window.isPrint) {
          if (this.specialZoneSpecies) {
            this.zoneMessageModal = true;
          } else {
           this.zoneMessageModal = false;
          }
        }
      },

      canonicalSpecies: function (canonicalSpecies) {
        // abort any existing in flight requests
        if (this.inFlightRequest_herbarium_records) {
          this.inFlightRequest_herbarium_records.abort();
          this.inFlightRequest_herbarium_records = null;
        }

        // invalidate the map data so it's not shown while loading
        if (this.map) {
          this.map.getSource('herbarium_records').setData(this.emptyGeoJSON);
          this.map.getSource('special_zone').setData(this.emptyGeoJSON);
        }

        this.updateZoneWithCanonicalSpecies(canonicalSpecies)

        if (canonicalSpecies) {
          this.inFlightRequest_herbarium_records = json('data/herbarium_records/' + canonicalSpecies.replace(' ', '_') + '.geojson', (data) => {
            this.inFlightRequest_herbarium_records = null;

            this.herbarium_records = data
            if (this.map) {
              this.map.getSource('herbarium_records').setData(data);
            }
            this.herbarium_records_state = 'loaded';

            resultsModalMapIds.forEach((map) => {
              if (this[map] && this[map].getSource('herbarium_records')) {
                this[map].getSource('herbarium_records').setData(data);
              }
            })
          });

          if (this.lng && this.lat) {
            if (window.isPrint && window.gdm_prediction_masked) {
              // do nothing, since we are printing and have the data already loaded
            } else {
              this.queryModel(this.lng, this.lat, canonicalSpecies);
            }
          } else {
            // if lng lat not yet set, move the stepper
            this.step = 1;
          }
          if (this.domainGeoJSON && !(this.lng && this.lat)) { // only show the domain if choosing a location after selecting a species
            var domain = this.domainGeoJSON.features.find((feature) => {
              return feature.properties.species == canonicalSpecies;
            });
            if (domain) {
              if (this.map) {
                this.map.getSource('domain-mask').setData(mask(domain));
              }
            }
          }
        }
      },
      herbarium_records_toggle: function (val) {
        this.map.setLayoutProperty('herbarium_records', 'visibility', val ? 'visible' : 'none');

        this.$gtag.event('toggle_herbarium_records', {
          event_category: 'interaction',
          event_label: `Toggle Herbarium Records ${val ? 'On' : 'Off'}`
        })
      },
      recommended_collection_area_toggle: function (val) {
        this.map.setLayoutProperty('gdm_prediction', 'visibility', val ? 'visible' : 'none');

        this.$gtag.event('toggle_recommended_collection_area', {
          event_category: 'interaction',
          event_label: `Toggle Recommended collection area ${val ? 'On' : 'Off'}`
        })
      },
      similar_environments_current_toggle: function (val) {
        this.map.setLayoutProperty('current_climate_match', 'visibility', val ? 'visible' : 'none');

        this.$gtag.event('toggle_similar_environments_current', {
          event_category: 'interaction',
          event_label: `Toggle Similar environments (Current) ${val ? 'On' : 'Off'}`
        })
      },
      similar_environments_future_toggle: function (val) {
        this.map.setLayoutProperty('future_climate_match', 'visibility', val ? 'visible' : 'none');

        this.$gtag.event('toggle_similar_environments_2050', {
          event_category: 'interaction',
          event_label: `Toggle Similar environments (2050) ${val ? 'On' : 'Off'}`
        })
      },
      map_background: function (val) {
        var currentStyle = this.map.getStyle();
        json(`https://api.mapbox.com/styles/v1/mapbox/${val}?access_token=${mapboxgl.accessToken}`, (style) => {
          style.sources = Object.assign({}, currentStyle.sources, style.sources);
          var labelIndex = style.layers.findIndex((el) => {
            return el.id == 'waterway-label';
          });
          var appLayers = currentStyle.layers.filter((el) => {
            return (el.source && el.source != "mapbox://mapbox.satellite" && el.source != "composite");
          });
          appLayers.reverse();
          appLayers.forEach((layer) => {
            if (layer.id === 'gdm_prediction') {
              if (val === 'satellite-streets-v10') {
                for (var property in Style.gdm_prediction_dark) {
                  layer[property] = Style.gdm_prediction_dark[property];
                }
              } else {
                for (var property in Style.gdm_prediction) {
                  layer[property] = Style.gdm_prediction[property];
                }
              }
            }
            style.layers.splice(labelIndex, 0, layer);
          });

          this.map.setStyle(style);
        });

        this.$gtag.event(`map_background_${val === 'streets-v10' ? 'map' : 'satellite'}`, {
          event_category: 'interaction',
          event_label: `Map Background change to ${val === 'streets-v10' ? 'Map' : 'Satellite'}`
        })
      },
      resultsModal: function (val) {
        this.waitFor([
          'gdm_prediction_bbox',
          'gdm_prediction_masked',
          'current_climate_match',
          'future_climate_match'
        ], () => {
          if (val && !this.resultsMapGeneticDiversity) { // modal opened for the first time
            resultsModalMapIds.forEach((map) => {
              this[map] = new mapboxgl.Map({
                container: map,
                style: 'mapbox:///mapbox/streets-v9',
                center: [this.lng, this.lat],
                zoom: 4,
                interactive: false,
                preserveDrawingBuffer: true
              });
              //setTimeout(() => {
              //}, 1000);

              this[map].on('load', () => {
                this[map].resize();
                if (this.gdm_prediction_bbox) {
                  this[map].fitBounds(this.gdm_prediction_bbox, {
                    padding: 20,
                    duration: 0
                  });
                }

                (new mapboxgl.Marker()).setLngLat([this.lng, this.lat]).addTo(this[map]);

                this[map].addSource('herbarium_records', {
                  type: 'geojson',
                  data: this.inFlightRequest_herbarium_records ? this.emptyGeoJSON : this.herbarium_records
                });
                this[map].addLayer(Style.herbarium_records , 'waterway-label');

                this[map].addSource('special_zone', {
                  type: 'geojson',
                  data: this.zone ? this.zone : this.emptyGeoJSON
                });
                this[map].addLayer(Style.specialZones, 'waterway-label');

                this[map].addSource('gdm_prediction', {
                  type: 'geojson',
                  data: window.gdm_prediction_masked || this.map.getSource('gdm_prediction')._data
                });
                this[map].addLayer(Style.gdm_prediction);

                if (map === 'resultsMapCurrentClimateMatch') {
                  this[map].addSource('current_climate_match', {
                    type: 'geojson',
                    data: window.current_climate_match || this.map.getSource('current_climate_match')._data
                  });
                  this[map].addLayer(Style.current_climate_match, 'housenum-label');
                }

                if (map === 'resultsMapFutureClimateMatch') {
                  this[map].addSource('future_climate_match', {
                    type: 'geojson',
                    data: window.future_climate_match || this.map.getSource('future_climate_match')._data
                  });
                  this[map].addLayer(Style.future_climate_match, 'housenum-label');
                }
                this[map].on('render', () => {
                  if (this[map].areTilesLoaded() && this[map].loaded() && this[map].isStyleLoaded() && !this[`resultsMapReady_${map}`]) {
                    this[`resultsMapReady_${map}`] = true;

                    if (
                      this.resultsMapReady_resultsMapGeneticDiversity &&
                      this.resultsMapReady_resultsMapCurrentClimateMatch &&
                      this.resultsMapReady_resultsMapFutureClimateMatch
                    ) {
                      window.resultsMapReady = true;
                    }
                  }
                })
              });
            });
          } else if (val) { // modal opened subsequent times
            resultsModalMapIds.forEach((map) => {
              setTimeout(() => {
                this[map].resize();
              }, 1000);
            });
          }
        });
      },
      collapsed: function (collapsed) {
        this.$gtag.event(`panel_${collapsed ? 'closed' : 'opened'}`, {
          event_category: 'interaction',
          event_label: `Panel ${collapsed ? 'Closed' : 'Opened'}`
        })
      }
    },
    methods: {
      determineInSpecialZone: function (ll) {
        // Added PDW 2020-08-31
        var specialZone = this.specialZoneQuery ? this.specialZoneQuery(ll, true) : null;
        if (specialZone) {
          this.inSpecialZone = true;
          this.zoneMessage = this.zoneMessages ? this.zoneMessages[this.canonicalSpecies] : null;
        } else {
          this.inSpecialZone = false;
          this.zoneMessage = null;
        }
      },
      updateZoneWithCanonicalSpecies: function (canonicalSpecies) {
        if (this.hasSpecialZone && this.hasSpecialZone[canonicalSpecies] === 'TRUE') { // PDW 2020-08-30
          this.specialZoneSpecies = true;

          if (this.inSpecialZone) {
            if (!window.isPrint) {
              this.zoneMessageModal = true;
            }
            this.zoneMessage = this.zoneMessages ? this.zoneMessages[canonicalSpecies] : null;
          } else {
            this.zoneMessageModal = false;
            this.zoneMessage = null;
          }

          // fetch special zone polygon(s) from topoJSON object
          this.zone = this.specialZoneGeoJSON ? this.specialZoneGeoJSON.features.find((feature) => {
            return feature.properties.species == canonicalSpecies;
          }) : null;

          if (this.zone) {
            if (this.map && this.map.getSource('special_zone')) {
              this.map.getSource('special_zone').setData(this.zone);
            }
          }
        } else {
          this.specialZoneSpecies = false;
          if (this.map && this.map.getSource('special_zone')) {
            this.map.getSource('special_zone').setData(this.emptyGeoJSON);
          }
        }
      },
      speciesInfoModalClicked: function () {
        this.$gtag.event('species_info_button_clicked', {
          event_category: 'interaction',
          event_label: 'Species Info Button Clicked'
        })
      },
      waitFor: function (windowVariables, callback) {
        if (windowVariables.map((windowVariable) => { return window[windowVariable] }).every((v) => {return v})) {
          windowVariables.map((windowVariable) => {
            this[windowVariable] = window[windowVariable]
          })
          callback();
        } else {
          setTimeout(() => { this.waitFor(windowVariables, callback); }, 500);
        }
      },
      displayHelpClicked: function () {
        // Display a static help page in a new tab
        var helpWindow = window.open();
        helpWindow.document.write(RandR.helpPage);

        this.$gtag.event('help', {
          event_category: 'interaction',
          event_label: 'Help'
        })
      },
      downloadResults: function () {
        this.downloadResultsProgress = 0

        const startTime = window.performance ? performance.now() : null

        if (this.downloadResultsInterval) {
          window.clearInterval(this.downloadResultsInterval)
          this.downloadResultsInterval = null
        }

        // tick every 100ms to reach 100% in 10s
        const totalEstimatedTime = 20 * 1000 // 20s as milliseconds
        const intervalDuration = 500 // in milliseconds
        const totalTicks = totalEstimatedTime / intervalDuration

        this.downloadResultsInterval = window.setInterval(() => {
          this.downloadResultsProgress += 100 / totalTicks
        }, intervalDuration)

        this.inFlightRequest_downloadResults = request('/webtool/print')
          .mimeType('application/pdf')
          .header('Content-Type', 'application/json; charset=UTF-8')
          .responseType('blob')
          .post(JSON.stringify({

            lng: this.lng,
            lat: this.lat,
            species: this.selectedSpecies,
            canonicalSpecies: this.canonicalSpecies,

            // prefill the data to speed up the processing
            speciesTaxon: this.speciesTaxon,
            gdm_prediction_masked: this.data_gdm_prediction_masked,
            gdm_prediction_bbox: this.gdm_prediction_bbox,
            current_climate_match: this.data_current_climate_match,
            future_climate_match: this.data_future_climate_match
          }), (err, res) => {
            if (err) {
              console.error(err);
            } else {
              const fileName = `Restore and Renew Results ${this.selectedSpecies}.pdf`;
              if (navigator.msSaveBlob) {
                navigator.msSaveBlob(res.response, fileName);
              } else {
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(res.response);
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
              }
            }
            this.inFlightRequest_downloadResults = null;

            if (this.downloadResultsInterval) {
              window.clearInterval(this.downloadResultsInterval)
              this.downloadResultsInterval = null
            }

            this.$gtag.event('download_results_complete', {
              event_category: 'interaction',
              event_label: 'Download Results Complete',
              value: window.performance ? Math.round(performance.now() - startTime) : null
            })
          })

        this.$gtag.event('download_results', {
          event_category: 'interaction',
          event_label: 'Download Results'
        })
      },
      submitClicked: function() {
        // User has manually entered lat/long values: pass them over to this.lat and this.lng which will trigger map marker placement, etc
        this.lat = this.latInput;
        this.lng = this.lngInput;

        this.$gtag.event('set_location_via_coordinates', {
          event_category: 'interaction',
          event_label: 'Set Location via Coordinates'
        })
      },
      // given a component just finished loading, check if there are any more components to load, and if not, remove the loading screen
      checkLoaded: function (componentJustCompleted) {
        this.componentsToLoad[componentJustCompleted] = false;

        var allLoaded = Object.values(this.componentsToLoad).reduce((acc, cur) => { return acc || cur }, false);
        if (allLoaded) {
          window.loadingScreen.finish();
        }
      },
      reset: function (e) {
        this.selectedSpecies = null;
        this.lng = null;
        this.lat = null;
        this.lngInput = null;
        this.latInput = null;
        this.noSpeciesAtThisLocation = false;
        this.noLatLong = true;
        this.inSpecialZone = false;
        this.specialZoneSpecies = false;

        // go to location step
        this.step = 1;

        // abort any existing in flight requests
        ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach((i) => {
          if (this[`inFlightRequest_${i}`]) {
            this[`inFlightRequest_${i}`].abort();
            this[`inFlightRequest_${i}`] = null;
          }
          });

        this.$gtag.event('reset', {
          event_category: 'interaction',
          event_label: 'Reset'
        })
      },
      drawerCollapseToggled: function (e) {
        if (e.propertyName == 'transform') {
          this.tether.position();
          if (this.map)
            this.map.resize();
        }
      },
      print: function () { // print the results modal
        this.printing = true;
        var self = this;
        var bounds = {};

        function renderEvent() {
          const isEveryMapLoaded = resultsModalMapIds.map((map) => {
            return self[map].loaded();
          }).every((v) => { return v; });

          if (isEveryMapLoaded) {
            resultsModalMapIds.map((map) => {
              self[map].off('render', renderEvent);
            });

            setTimeout(function() {
              window.print();
              document.getElementById('app').removeAttribute('style');
              resultsModalMapIds.map((map) => {
                document.getElementById(map).removeAttribute('style');
                self[map].resize();
                self[map].fitBounds(bounds[map], {
                  padding: 0,
                  linear: true,
                  duration: 0
                });
              });

              self.printing = false;
            }, 2000);
          }
        }

        // set the page size as A4 Landscape
        document.getElementById('app').setAttribute('style', 'width: 29.7cm;');

        resultsModalMapIds.map((map) => {
          bounds[map] = self[map].getBounds();
        })
        resultsModalMapIds.map((map) => {
          self[map].on('render', renderEvent);
          document.getElementById(map).setAttribute('style', 'height: 18cm;');

          self[map].resize();
          self[map].fitBounds(bounds[map], {
            padding: 0,
            linear: true,
            duration: 0
          });
        });
      },
      locationUpdated: _.debounce(function () {
        if (this.lng && this.lat) {
          const ll = [this.lng, this.lat];
          // set marker location

          // We have lat/long values so unset the noLatLong flag
          this.noLatLong = false;

          if (this.domainQuery) {
            var domains = this.domainQuery(ll, true);
            if (domains) {
              this.noSpeciesAtThisLocation = false;
              this.speciesForThisLocation = domains.map((domain) => { return domain.species; }).sort();

              this.determineInSpecialZone(ll)

              // FIXME if canonicalSpecies already set put into an error state
              console.log("domainQuery before setting this.step = 2");
              this.step = 2;
            } else {
              // no domains found for this location
              this.noSpeciesAtThisLocation = true;
              this.speciesForThisLocation = [];
            }
          }

          if (this.map) {
            this.marker.setLngLat(ll).addTo(this.map);
            this.map.easeTo({
              center: ll
            });
          }

          if (this.canonicalSpecies) {
            if (this.map)
              this.queryModel(this.lng, this.lat, this.canonicalSpecies);
          }
        } else {
          // remove from map
          if (this.marker)
            this.marker.remove();

          ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach((i) => {
            if (this[`inFlightRequest_${i}`]) {
              this[`inFlightRequest_${i}`].abort();
              this[`inFlightRequest_${i}`] = null;
            }

            // invalidate any data on the map since one of the location values is not set yet
            if (this.map)
              this.map.getSource(i).setData(this.emptyGeoJSON);

            // Remove previous speciesAtThisLocation items
            this.speciesForThisLocation = [];

            // Set flag warning of no lat/long
            this.noLatLong = true;
          });
        }
      }, 100),
      /**
       * Set up the map to handle setting the location for restoration
       *
       * Including:
       *  - clicking on the map
       *  - result from search
       *  - geolocation
       */
      enableLocationSelection: function () {
        if (this.mapLoaded) {
          this.map.getCanvasContainer().style.cursor = 'crosshair';
          this.map.on('click', this.locationClick);
        } else {
          this.enableLocationSelectionWhenLoaded = true;
        }
      },

      /**
       * Unset handlers from enableLocationSelection
       */
      disableLocationSelection: function () {
        if (this.map) {
          this.map.getCanvasContainer().style.cursor = 'auto';
          this.map.off('click', this.locationClick);
        }
      },

      locationClick: function (e) {
        this.lng = e.lngLat.lng.toFixed(6);
        this.lat = e.lngLat.lat.toFixed(6);
        this.latInput = this.lat;
        this.lngInput = this.lng;

        this.$gtag.event('set_location_via_map', {
          event_category: 'interaction',
          event_label: 'Set Location via Map'
        })
      },

      stepperChanged: function (step) {
        (step == 1) ? this.enableLocationSelection() : this.disableLocationSelection();
      },

      queryModel: function(lng, lat, taxonName) {
        this.resultsError = false;

        // abort any existing in flight requests
        ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach((i) => {
          if (this[`inFlightRequest_${i}`]) {
            this[`inFlightRequest_${i}`].abort();
            this[`inFlightRequest_${i}`] = null;
          }

          // invalidate any data on the map while loading
          if (this.map)
            this.map.getSource(i).setData(this.emptyGeoJSON);
        });

        // go to results step
        this.step = 3;
        if (this.map)
          this.map.getSource('domain-mask').setData(this.emptyGeoJSON); // FIXME this should be more robust for corner cases

        ['gdm_prediction', 'current_climate_match', 'future_climate_match'].forEach((i) => {
          this[`inFlightRequest_${i}`] = request('/api/' + i.replace(/_/g, '-'))
            .mimeType('application/json')
            .header('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
            .post(queryString.stringify({
              longitude: lng,
              latitude: lat,
              taxonName: '"' + taxonName + '"'
            }), (err, xhr) => {
              this[`inFlightRequest_${i}`] = null;
              if (err) {
                this.resultsError = true;
                console.error(err);
              } else {
                var geojson = JSON.parse(xhr.responseText);
                this[`data_${i}`] = geojson;
                window[i] = geojson;

                if (i == 'gdm_prediction') {
                  this.gdm_prediction_bbox = bbox(geojson);
                  window.gdm_prediction_bbox = this.gdm_prediction_bbox
                  if (this.map) {
                    this.map.fitBounds(this.gdm_prediction_bbox, {
                      duration: 0,
                      padding: 20
                    });
                  }

                  var combined = combine(geojson);
                  if (combined && combined.features && combined.features.length) {
                    this[`data_${i}_masked`] = difference({
                      "type": "Feature",
                      "properties": {},
                      "geometry": {
                        "type": "Polygon",
                        "coordinates": [
                          [
                            [ 180, 90 ],
                            [ 180, -90 ],
                            [ -180, -90 ],
                            [ -180, 90 ],
                            [ 180, 90 ]
                          ]
                        ]
                      }
                    }, combined.features[0]);
                    window[`${i}_masked`] = this[`data_${i}_masked`]
                    if (combined.features.length != 1) {
                      console.error("Combine created too many features: ", combined);
                    }
                  } else {
                    console.error("Couldn't combine GeoJSON: ", geojson);
                  }
                  if (this.map)
                    this.map.getSource(i).setData(this[`data_${i}_masked`] || this[`data_${i}`]);
              } else {
                if (this.map)
                  this.map.getSource(i).setData(geojson);
              }
            }
          });
        });
      }
    }
  }
</script>

<style>
  html {
    overflow-y: auto;
  }
  ol {
    padding-left: 15px;
  }
  ul {
    padding-left: 30px;
  }
  .logo {
    width: 100%;
  }
  .map-container{
    padding: 0;
    margin: 0;
  }
  .fill-height {
    height: 100vh;
  }
  #map {
    height: 100%;
    width: 100%;
  }
  .permalink-box {
    background: white;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .input-group__details {
    min-height: 0px !important;
  }
  .stepper {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .stepper--vertical {
    padding-bottom: 0;
  }
  .navigation-drawer {
    padding-bottom: 0;
  }

  .map-background {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-bottom: 30px;
    margin-right: 10px;
  }

  .canonicalSpecies {
    font-style: italic;
  }

  .results-list .list__tile {
    padding: 0;
  }
  .results-list .list__tile__avatar {
    min-width: 35px;
  }
  .results-list .v-input--selection-controls {
    margin-top: 0px !important;
  }

  .resultActions {
    background-color: lightgray;
  }

  .stepper-results .v-list__tile__avatar {
    min-width: 30px;
  }
  .stepper-results .v-list__tile {
    padding-left: 0px;
  }

  .print { display: none; }
  @media print {
    @page {
      size: A4 landscape;
      margin: 1cm;
    }

    html {
      /*
        print background
        https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-print-color-adjust
       */
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }
    .map {
      height: 18cm !important;
    }
    .dialog__content__active {
      position: absolute !important; /* needed to print all pages */
    }
    .printSection {
      page-break-inside: avoid;
    }
    .application--wrap { display: none; }
    .resultActions { display: none; }

    /* show elements reserved for print */
    .print { display: block; }

    /* remove UI elements */
    .mapboxgl-ctrl-geocoder { display: none !important; }
    .mapboxgl-ctrl-zoom-in { display: none !important; }
    .mapboxgl-ctrl-zoom-out { display: none !important; }
    .mapboxgl-ctrl-geolocate { display: none !important; }
    #drawerCollapseButton { display: none; }
    .map-background { display: none; }

    /* carousel buttons */
    .v-carousel__prev { display: none !important; }
    .v-carousel__next { display: none !important; }
    .v-carousel__controls { display: none !important; }

    /* clean up stepper */
    .navigation-drawer { overflow: hidden; }
    .stepper__step { display: none; }
    .stepper__content {
      margin-left: 0 !important;
      padding-top: 0 !important;
    }
    .results-list { display: none !important; }

    /* hide all other steps except for results */
    .stepper__wrapper {
      display: none;
    }
    .stepper-results > .stepper__wrapper {
      height: auto !important;
      display: block;
    }

    .permalink-print {
      overflow-wrap: break-word;
    }

    .btn {
      display: none;
    }

    .shareLink {
      display: none;
    }

    .v-dialog--fullscreen {
      position: absolute;
      height: auto;

      box-shadow: none;
    }
    .v-dialog__content--active {
      position: absolute;
      height: auto;
    }
    img, .mapboxgl-map, .avoid-page-break {
      break-inside: avoid;
    }
  }

  .welcome-sponsor-logos {
    padding: 10px;
    max-height: 100px;
  }

  /* loading screen */
  .loading-message {
    font-family: 'Avenir';
    font-size: 200%;
    color: white;
  }
  .sk-chasing-dots .sk-child {
    background-color: white;
  }
  .pg-loading-logo-header {
    display: none;
  }
  .loading-message a {
    color: lightblue;
  }

  /* species info modal */
  .infoModal figure img {
    max-width: 100%;
    height: auto;
  }
  .infoModal .headline {
    font-weight: bold;
  }
  .infoModal .map {
    height: 800px;
  }
  .infoModal .section {
    min-height: 800px;
  }
  .infoModal .alert {
    margin-bottom: 16px;
  }

  .infoModal {
    font-size: 110%;
  }

  .defaultMarker.small svg {
    max-height: 30px;
  }

  .loading-spin {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue